import axios from 'axios';
import { requestHelpers } from 'helpers';
import { responseHelpers } from 'helpers';
import { userServices } from 'services';
import '@terra-js/web-bridge';
import TerraKit from '@terra-js/terra-kit';
import { responseConstants } from 'constants/index';

const { CODE_TOKEN_EXPIRED, STATUS_UNAUTHORIZE } = responseConstants;

const merchantOnboard = axios.create({
  baseURL: `${window.REACT_APP_MERCHANT_ONBOARD_URL}`,
});

const locationService = axios.create({
  baseURL: `${window.REACT_APP_BFF_DOMAIN}/api`,
});

const getAuthorization = async () => {
  return `Bearer ${await userServices.getAccessToken()}`;
};

// Do something before request is sent
const requestInterceptor = async (request: any) => {
  request.headers.Authorization = await getAuthorization();
  switch (request.baseURL) {
    case window.REACT_APP_SKIP_IAM:
      // @TODO: will remove when IAM fixed
      request.headers['X-User-Email'] = 'hoang.pt@teko.vn';
      break;
    default:
      break;
  }
  return request;
};

// Any status code that lie within the range of 2xx cause this function to trigger
const responseSuccessInterceptor = (response: any) => {
  responseHelpers.handleResponseSuccess(response);
  return response;
};

// Any status codes that falls outside the range of 2xx cause this function to trigger
const responseErrorInterceptor = async (error: any) => {
  const recallPromise = await requestHelpers.handleResponseError(error);
  return TerraKit.isAvailable() &&
    error?.response?.status === STATUS_UNAUTHORIZE &&
    error?.response?.data?.error?.code === CODE_TOKEN_EXPIRED
    ? recallPromise
    : Promise.reject(error);
};

const clients = [merchantOnboard, locationService];

clients.forEach(client => {
  client.interceptors.request.use(requestInterceptor);
  client.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
  );
});

export default {
  merchantOnboard,
  locationService,
};
